export class ClientError extends Error {
    constructor(message: string) {
        super(message);
    }
}

export class ClientOfflineError extends ClientError {
    constructor() {
        super("Client is offline");
    }
}
